var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85848 5.53176L1.51833 0.191706C1.39482 0.068097 1.22994 0 1.05414 0C0.878334 0 0.713458 0.068097 0.589947 0.191706L0.196681 0.584873C-0.0592189 0.841066 -0.0592189 1.25745 0.196681 1.51326L4.68094 5.99751L0.191706 10.4867C0.0681946 10.6104 0 10.7751 0 10.9508C0 11.1267 0.0681946 11.2915 0.191706 11.4152L0.584971 11.8083C0.70858 11.9319 0.873359 12 1.04916 12C1.22497 12 1.38984 11.9319 1.51335 11.8083L6.85848 6.46336C6.98229 6.33936 7.05028 6.1738 7.04989 5.99781C7.05028 5.82112 6.98229 5.65566 6.85848 5.53176Z",
    fill: "#3F6BAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrow);
export default __webpack_public_path__ + "static/media/blue-arrow.952695524915807e23e57d11a2ddb33f.svg";
export { ForwardRef as ReactComponent };